/**
  入库路由配置
*/
import React from 'react';
import PutonAbnormalList from '@/pages/PutonAbnormalList';
import PutonAbnormalUpdate from '@/pages/PutonAbnormalUpdate';
import PutonDetail from '@/pages/PutonDetail';
import PutonDetailList from '@/pages/PutonDetailList';
import PutonList from '@/pages/PutonList';
import PutonStepList from '@/pages/PutonStepList';
import ReceivingPlan from '@/pages/Receivingplan';
import Booking from '@/pages/Booking';
import ReceiptList from '@/pages/ReceiptList';
import ReceiptDetail from '@/pages/ReceiptDetail';
import ReceiptDetailList from '@/pages/ReceiptDetailList';
import ReceiptStepList from '@/pages/ReceiptStepList';
import ReceiptAbnormalList from '@/pages/ReceiptAbnormalList';
import ReceiptAbnormalUpdate from '@/pages/ReceiptAbnormalUpdate';
import ReceiptGoodsAbnor from '@/pages/ReceiptGoodsAbnor';
import ReceiptGoodsDetail from '@/pages/ReceiptGoodsDetail';
import DischargeTask from '@/pages/DischargeTask';
import DischargeDetail from '@/pages/DischargeDetail';
import DischargeStep from '@/pages/DischargeStep';
import DischargeAll from '@/pages/DischargeAll';
import DischargeChart from '@/pages/DischargeChart';
import CabiNet from '@/pages/CabiNet';
import Returned from '@/pages/Returned';
import ReturnenFind from '@/pages/ReturnenFind';
import ReturnedStep from '@/pages/ReturnedStep';
import ReturnedAbnor from '@/pages/ReturnedAbnor';
import GrounDing from '@/pages/GrounDing';
import GrounDingDetail from '@/pages/GrounDingDetail';
import GrounDingFind from '@/pages/GrounDingFind';
import GrounDingStep from '@/pages/GrounDingStep';
import GrounDingAbnor from '@/pages/GrounDingAbnor';
import BookingDetail from '@/pages/BookingDetail';
import ReturnDetail from '@/pages/ReturnDetail';
import BatchManage from '@/pages/BatchManage';
// import BounceReiptTask from '@/pages/BounceReiptTask';
// import BounceReceiptTask from '@/pages/BounceReceiptTask';
// import { lazy } from 'ice';
// const ReturnDetail = lazy(() => import(/* webpackChunkName: 'ReturnDetail' */ '@/pages/ReturnDetail'));
// const PutonAbnormalList = lazy(() => import(/* webpackChunkName: 'PutonAbnormalList' */ '@/pages/PutonAbnormalList'));
// const PutonDetail = lazy(() => import(/* webpackChunkName: 'PutonDetail' */ '@/pages/PutonDetail'));
// const PutonDetailList = lazy(() => import(/* webpackChunkName: 'PutonDetailList' */ '@/pages/PutonDetailList'));
// const PutonList = lazy(() => import(/* webpackChunkName: 'PutonList' */ '@/pages/PutonList'));
// const PutonStepList = lazy(() => import(/* webpackChunkName: 'PutonStepList' */ '@/pages/PutonStepList'));
// const ReceivingPlan = lazy(() => import(/* webpackChunkName: 'ReceivingPlan' */ '@/pages/Receivingplan'));
// const Booking = lazy(() => import(/* webpackChunkName: 'Booking' */ '@/pages/Booking'));
// const ReceiptList = lazy(() => import(/* webpackChunkName: 'ReceiptList' */ '@/pages/ReceiptList'));
// const ReceiptDetail = lazy(() => import(/* webpackChunkName: 'ReceiptDetail' */ '@/pages/ReceiptDetail'));
// const ReceiptDetailList = lazy(() => import(/* webpackChunkName: 'ReceiptDetailList' */ '@/pages/ReceiptDetailList'));
// const ReceiptStepList = lazy(() => import(/* webpackChunkName: 'ReceiptStepList' */ '@/pages/ReceiptStepList'));
// const ReceiptAbnormalList = lazy(
//   () => import(/* webpackChunkName: 'ReceiptAbnormalList' */ '@/pages/ReceiptAbnormalList'),
// );
// const DischargeTask = lazy(() => import(/* webpackChunkName: 'DischargeTask' */ '@/pages/DischargeTask'));
// const DischargeDetail = lazy(() => import(/* webpackChunkName: 'DischargeDetail' */ '@/pages/DischargeDetail'));
// const DischargeStep = lazy(() => import(/* webpackChunkName: 'DischargeStep' */ '@/pages/DischargeStep'));
// const DischargeAll = lazy(() => import(/* webpackChunkName: 'DischargeAll' */ '@/pages/DischargeAll'));
// const DischargeChart = lazy(() => import(/* webpackChunkName: 'DischargeChart' */ '@/pages/DischargeChart'));
// const CabiNet = lazy(() => import(/* webpackChunkName: 'CabiNet' */ '@/pages/CabiNet'));
// const Returned = lazy(() => import(/* webpackChunkName: 'Returned' */ '@/pages/Returned'));
// const ReturnenFind = lazy(() => import(/* webpackChunkName: 'ReturnenFind' */ '@/pages/ReturnenFind'));
// const ReturnedStep = lazy(() => import(/* webpackChunkName: 'ReturnedStep' */ '@/pages/ReturnedStep'));
// const ReturnedAbnor = lazy(() => import(/* webpackChunkName: 'ReturnedAbnor' */ '@/pages/ReturnedAbnor'));
// const GrounDing = lazy(() => import(/* webpackChunkName: 'GrounDing' */ '@/pages/GrounDing'));
// const GrounDingDetail = lazy(() => import(/* webpackChunkName: 'GrounDingDetail' */ '@/pages/GrounDingDetail'));
// const GrounDingFind = lazy(() => import(/* webpackChunkName: 'GrounDingFind' */ '@/pages/GrounDingFind'));
// const GrounDingStep = lazy(() => import(/* webpackChunkName: 'GrounDingStep' */ '@/pages/GrounDingStep'));
// const GrounDingAbnor = lazy(() => import(/* webpackChunkName: 'GrounDingAbnor' */ '@/pages/GrounDingAbnor'));
// const BookingDetail = lazy(() => import(/* webpackChunkName: 'BookingDetail' */ '@/pages/BookingDetail'));

export default [
  {
    path: '/inbound/puton/list',
    component: React.lazy(() => import(/* webpackChunkName: 'PutonList' */ '@/pages/PutonList')),
  },
  {
    path: '/inbound/puton/detail/:tid',
    // component: PutonDetail,
    component: React.lazy(() => import(/* webpackChunkName: 'PutonDetail' */ '@/pages/PutonDetail')),
  },
  {
    path: '/inbound/puton/detailList',
    // component: PutonDetailList,
    component: React.lazy(() => import(/* webpackChunkName: 'PutonDetailList' */ '@/pages/PutonDetailList')),
  },
  {
    path: '/inbound/puton/stepList',
    // component: PutonStepList,
    component: React.lazy(() => import(/* webpackChunkName: 'PutonStepList' */ '@/pages/PutonStepList')),
  },
  {
    path: '/inbound/puton/abnormalList',
    // component: PutonAbnormalList,
    component: React.lazy(() => import(/* webpackChunkName: 'PutonAbnormalList' */ '@/pages/PutonAbnormalList')),
  },
  {
    path: '/inbound/puton/updateAbnormal/:jobNo',
    // component: PutonAbnormalUpdate,
    component: React.lazy(() => import(/* webpackChunkName: 'PutonAbnormalUpdate' */ '@/pages/PutonAbnormalUpdate')),
  },
  {
    path: '/inbound/receipt/list',
    // component: ReceiptList,
    component: React.lazy(() => import(/* webpackChunkName: 'ReceiptList' */ '@/pages/ReceiptList')),
  },
  {
    path: '/inbound/receipt/detail/:tid',
    // component: ReceiptDetail,
    component: React.lazy(() => import(/* webpackChunkName: 'ReceiptDetail' */ '@/pages/ReceiptDetail')),
  },
  {
    path: '/inbound/receipt/detailList',
    // component: ReceiptDetailList,
    component: React.lazy(() => import(/* webpackChunkName: 'ReceiptDetailList' */ '@/pages/ReceiptDetailList')),
  },
  {
    path: '/inbound/receipt/stepList',
    // component: ReceiptStepList,
    component: React.lazy(() => import(/* webpackChunkName: 'ReceiptStepList' */ '@/pages/ReceiptStepList')),
  },
  {
    path: '/inbound/receipt/abnormalList',
    // component: ReceiptAbnormalList,
    component: React.lazy(() => import(/* webpackChunkName: 'ReceiptAbnormalList' */ '@/pages/ReceiptAbnormalList')),
  },
  {
    path: '/inbound/receipt/updateAbnormal/:receiveDetailNo',
    // component: ReceiptAbnormalUpdate,
    component: React.lazy(
      () => import(/* webpackChunkName: 'ReceiptAbnormalUpdate' */ '@/pages/ReceiptAbnormalUpdate'),
    ),
  },
  {
    path: '/inbound/receipt/goodsAbnor',
    // component: ReceiptGoodsAbnor,
    component: React.lazy(() => import(/* webpackChunkName: 'ReceiptGoodsAbnor' */ '@/pages/ReceiptGoodsAbnor')),
  },
  {
    path: '/inbound/receipt/goodsAbnorDetail/:tid',
    // component: ReceiptGoodsDetail,
    component: React.lazy(() => import(/* webpackChunkName: 'ReceiptGoodsDetail' */ '@/pages/ReceiptGoodsDetail')),
  },
  {
    path: '/inbound/ReceivingPlan/list',
    // component: ReceivingPlan,
    component: React.lazy(() => import(/* webpackChunkName: 'ReceivingPlans' */ '@/pages/Receivingplan')),
  },
  {
    path: '/inbound/ReceivingPlan/booking',
    // component: Booking,
    component: React.lazy(() => import(/* webpackChunkName: 'Booking' */ '@/pages/Booking')),
  },
  {
    path: '/inbound/ReceivingPlan/bookingDetail/:receivingPlanNo',
    // component: BookingDetail,
    component: React.lazy(() => import(/* webpackChunkName: 'BookingDetail' */ '@/pages/BookingDetail')),
  },
  {
    path: '/inbound/DischargeTask/list',
    // component: DischargeTask,
    component: React.lazy(() => import(/* webpackChunkName: 'DischargeTask' */ '@/pages/DischargeTask')),
  },
  {
    path: '/inbound/DischargeDetail/detail/:jobNo',
    // component: DischargeDetail,
    component: React.lazy(() => import(/* webpackChunkName: 'DischargeDetail' */ '@/pages/DischargeDetail')),
  },
  {
    path: '/inbound/DischargeTask/dischargeStep',
    // component: DischargeStep,
    component: React.lazy(() => import(/* webpackChunkName: 'DischargeStep' */ '@/pages/DischargeStep')),
  },
  {
    path: '/inbound/DischargeTask/dischargeAll',
    // component: DischargeAll,
    component: React.lazy(() => import(/* webpackChunkName: 'DischargeAll' */ '@/pages/DischargeAll')),
  },
  {
    path: '/inbound/DischargeTask/dischargeChart',
    // component: DischargeChart,
    component: React.lazy(() => import(/* webpackChunkName: 'DischargeChart' */ '@/pages/DischargeChart')),
  },
  {
    path: '/inbound/ReceivingPlan/unfindlist',
    // component: CabiNet,
    component: React.lazy(() => import(/* webpackChunkName: 'CabiNet' */ '@/pages/CabiNet')),
  },
  {
    path: '/inbound/Returned/list',
    // component: Returned,
    component: React.lazy(() => import(/* webpackChunkName: 'Returned' */ '@/pages/Returned')),
  },
  {
    path: '/inbound/Returned/detail/:jobNo',
    // component: ReturnDetail,
    component: React.lazy(() => import(/* webpackChunkName: 'ReturnDetail' */ '@/pages/ReturnDetail')),
  },
  {
    path: '/inbound/Returned/returnenFind',
    // component: ReturnenFind,
    component: React.lazy(() => import(/* webpackChunkName: 'ReturnenFind' */ '@/pages/ReturnenFind')),
  },
  {
    path: '/inbound/Returned/returnedStep',
    // component: ReturnedStep,
    component: React.lazy(() => import(/* webpackChunkName: 'ReturnedStep' */ '@/pages/ReturnedStep')),
  },
  {
    path: '/inbound/Returned/returnedAbnor',
    // component: ReturnedAbnor,
    component: React.lazy(() => import(/* webpackChunkName: 'ReturnedAbnor' */ '@/pages/ReturnedAbnor')),
  },
  {
    path: '/inbound/GrounDing/list',
    // component: GrounDing,
    component: React.lazy(() => import(/* webpackChunkName: 'GrounDing' */ '@/pages/GrounDing')),
  },
  {
    path: '/inbound/GrounDing/detail/:tid',
    // component: GrounDingDetail,
    component: React.lazy(() => import(/* webpackChunkName: 'GrounDingDetail' */ '@/pages/GrounDingDetail')),
  },
  {
    path: '/inbound/GrounDing/grounDingFind',
    // component: GrounDingFind,
    component: React.lazy(() => import(/* webpackChunkName: 'GrounDingFind' */ '@/pages/GrounDingFind')),
  },
  {
    path: '/inbound/GrounDing/grounDingStep',
    // component: GrounDingStep,
    component: React.lazy(() => import(/* webpackChunkName: 'GrounDingStep' */ '@/pages/GrounDingStep')),
  },
  {
    path: '/inbound/GrounDing/grounDingAbnor',
    // component: GrounDingAbnor,
    component: React.lazy(() => import(/* webpackChunkName: 'GrounDingAbnor' */ '@/pages/GrounDingAbnor')),
  },
  {
    path: '/inbound/puton/batchmanage',
    // component: BatchManage,
    component: React.lazy(() => import(/* webpackChunkName: 'BatchManage' */ '@/pages/BatchManage')),
  },
  {
    path: '/inbound/tally/exceptionList',
    component: React.lazy(() => import(/* webpackChunkName: 'TallyExceptionList' */ '@/pages/TallyExceptionList')),
  },
];
